<template>
  <div class="tabs-wap">
    <div class="tabs-list header" id="tabs">
      <label class="tabs-item" v-for="item in tabs" :key="item.key" :class="item.key === tabKey ? 'active' : ''" @click="tabsClick(item)">
        {{item.label}}
      </label>
    </div>
    <!-- style="min-height: 90vh;" -->
    <div id="tabConEle">
      <zixun-list v-if="tabKey === 'zixun'"></zixun-list>
      <gonggao-list v-if="tabKey === 'gonggao'"></gonggao-list>
      <yanbao-tab v-if="tabKey === 'yanbao'"></yanbao-tab>
      <!-- HK, USA, CN -->
      <jiankuang-tab v-if="tabKey === 'jiankuang' && region === 'CN'"></jiankuang-tab>
      <gmg-jiankuang v-if="tabKey === 'jiankuang' && region !== 'CN'"></gmg-jiankuang>
      <caibao-tab v-if="tabKey === 'caiwu'"></caibao-tab>
      <guba-tab v-if="tabKey === 'guba'"></guba-tab>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import zixunList from './zixunlist'
import gonggaoList from './gonggaolist'
import yanbaoTab from './yanbaotab'
import jiankuangTab from './jiankuangtab'
import gmgJiankuang from './gmgBrief'
import caibaoTab from './caibaotab'
import gubaTab from './gubatab'

export default {
  computed: {
    ...mapState({
      tabs: state => state.common.tabs,
      tabKey: state => state.common.tabKey,
      isIndex: state => state.isIndex,
      region: state => state.region
    })
  },
  created() {
    console.log(this.tabs, '=====')
  },
  components: {zixunList, gonggaoList, yanbaoTab, jiankuangTab, caibaoTab, gmgJiankuang, gubaTab},
  methods: {
    ...mapMutations({
      setTabKey: 'common/setTabKey',
      setTabIndex: 'common/setTabIndex'
    }),
    getElementTop(element) {
      var actualTop = element.offsetTop
      var current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }
      return actualTop
    },
    tabsClick(item) {
      let top = this.getElementTop(document.querySelector('#tabConEle'))
      window.scrollTo(0, top - 100)
      const index = this.tabs.findIndex(el => el.key === item.key)
      this.setTabKey(item.key)
      this.setTabIndex(index)
    }
  }
}
</script>

<style lang="stylus" scoped>
.tabs-wap
  margin-top 0.06rem
  height auto
  background #fff
  // 0px 7px
  .header
    position -webkit-sticky
    position sticky
    top .5rem
    background #fff
    z-index 101
  .tabs-list
    border-bottom 1px solid #edeff3
    display flex
    padding 0 7px
    .tabs-item
      font-size 15px
      margin 5px 0 0 0
      padding 7px 5px
      // margin-bottom 7px
      margin-right 12px
      font-weight 400
      height 21px
      line-height 21px
      &.active
        border-bottom 2px solid #f43737
        color #f43737
</style>